/**
 * StudioHeader — 태블릿/데스크탑 상단 수평 헤더
 *
 * 모바일에서는 숨김 (BottomNav 사용)
 * 640px+ 에서 표시
 */

import { NavLink } from 'react-router'
import { LogOut } from 'lucide-react'
import { useAuth } from '../../lib/auth.js'
import { Avatar } from '../ui/index.js'
import { STUDIO_NAV_ITEMS } from './navItems.js'
import styles from './StudioHeader.module.css'

export function StudioHeader() {
  const { user, logout } = useAuth()

  return (
    <header className={styles.root}>
      {/* 로고 / 브랜드 */}
      <div className={styles.brand}>
        <span className={styles.logo}>C</span>
        <span className={styles.brandName}>Cugumi</span>
        <span className={styles.brandTag}>STUDIO</span>
      </div>

      {/* 네비게이션 */}
      <nav className={styles.nav}>
        {STUDIO_NAV_ITEMS.map(({ to, label, icon: Icon, end }) => (
          <NavLink
            key={to}
            to={to}
            end={end}
            className={({ isActive }) =>
              `${styles.navItem} ${isActive ? styles.active : ''}`
            }
          >
            <Icon size={18} strokeWidth={1.8} className={styles.navIcon} />
            {label}
          </NavLink>
        ))}
      </nav>

      {/* 유저 영역 */}
      <div className={styles.userSection}>
        <Avatar
          src={user?.image ?? undefined}
          name={user?.name ?? user?.email ?? '?'}
          size="md"
        />
        <span className={styles.userName}>
          {user?.name ?? user?.email ?? ''}
        </span>
        <button className={styles.logoutBtn} onClick={logout} title="로그아웃">
          <LogOut size={18} strokeWidth={1.8} />
        </button>
      </div>
    </header>
  )
}
